var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-button',{staticClass:"text-bold",on:{"click":function($event){_vm.$router.push(("/admin/members/user?uuid=" + (_vm.params.data.uuid))).catch(function () {})}}},[_vm._v("\n        Go to overview\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }